import React from 'react';
import { OmniTableComponent } from './omni-components';
import { html } from 'lit';
import { LoaderComponent } from './loaderComponent';
import { Utils } from '../utils/utils';
import { CreatePlacementOrPackageService, PlacementDetailsTableService } from '../../features/placements';
import { AlertMessagesService } from '../services/alertMessages-service';
import { syncErrorService as SyncErrorService } from '../services/syncError-service';
export default class SyncErrorDialogComponent extends React.Component {
    defaultState = {
        selecedData: {},
        selectedButtonDisabled: true,
        spinnerCount: 0,
    };

    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    placementName = (value) => {
        let placementNameArr = value.placementName || [];
        let rows = placementNameArr.map((item) => {
            return html`<div style="color:${item.color ? item.color + ' !important' : ''}">
            <span>
             ${item.name}
            </span>
            </div>${item.delimiterValue}`
        })
        return rows;
    }

    type = (value) => {
        return html`<div part="type-cell">
        <span>
         ${value.package_type ? value.package_type : value.packageType ? value.packageType : ''}
        </span>
        </div>`
    }

    parameterCode = (value) => {
        let parameterCode =  value.parameterCode || [];
        let rows = parameterCode.map((item) => {
            return html`<div style="color:${item.color ? item.color + ' !important' : ''}">
            <span>
             ${item.name}
            </span>
            </div>${item.delimiterValue}`
        })
        return rows;
    }

    budget(value) {
        const placementName = value.placement_taxonomy ? value.placement_taxonomy  : '';       
        const isMohTable = value.error_description ? true : false;
        const plannedCost = value.planned_cost ? value.planned_cost : value.plannedCost ? value.plannedCost : '';
        const compareCost = isMohTable ? value?.moPlannedCost : value?.mohPlannedCost;

        const normalizedPlanned = this.toNumber(plannedCost);
        const normalizedCompare = this.toNumber(compareCost);
        const isDifferent = normalizedPlanned === normalizedCompare;

        for (const channel of this.props.campaignObj.channels) {
            if (channel?.channel_name?.toUpperCase() === placementName.toUpperCase()) {
                return html`
                <div>
                        <omni-tooltip-next part="financialIconToolTip">
                            <div slot="invoker" aria-haspopup="true"><omni-icon part="financialIcon" class="is-size-4 cursor" icon-id="omni:informative:financial"></omni-icon></div>
                            <div slot="content">
                                Media Budget: ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(channel.channel_total_budget)}<br>
                                Fees: ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(channel.channel_fees)}<br>
                                Authorized: ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(channel.channel_authorized_amount, true)}<br>
                            </div>
                        </omni-tooltip-next>
                        <span style="color: ${isDifferent ? '' : 'var(--text-error)'}"> ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(plannedCost)}</span>
                </div>
               `
            } 
            else if (value?.channel?.toUpperCase() === channel?.channel_name?.toUpperCase()) {
                for (const publisher of channel?.publishers) {
                    if (publisher?.publisher_name?.toUpperCase() === placementName.toUpperCase()) {
                        return html`
                        <div>
                                <omni-tooltip-next part="financialIconToolTip">
                                    <div slot="invoker" aria-haspopup="true"><omni-icon part="financialIcon" class="is-size-4 cursor" icon-id="omni:informative:financial"></omni-icon></div>
                                    <div slot="content">
                                        Authorized: ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(publisher.publisher_authorized_amount, true)}
                                    </div>
                                </omni-tooltip-next>
                                <span style="color: ${isDifferent ? '' : 'var(--text-error)'}"> ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(plannedCost)}</span>
                        </div>
                        `
                    }
                }
            }
        }
        return html`<span style="color: ${isDifferent ? '' : 'var(--text-error)'}"> ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(plannedCost)}</span>`
    }

    totalCost = (value) => {
        const isMohTable = value.error_description ? true : false;
        const plannedCost = value.planned_cost ? value.planned_cost : value.placementCost && value.placementCost.plannedCost.amount ? value.placementCost.plannedCost.amount : '';
        const compareCost = isMohTable ? value?.moPlannedCost : value?.mohPlannedCost;

        const normalizedPlanned = this.toNumber(plannedCost);
        const normalizedCompare = this.toNumber(compareCost);

        const isDifferent = normalizedPlanned === normalizedCompare;

        return html`<div part="total-cell">
        <span style="color: ${isDifferent ? '' : 'var(--text-error)'}">
         ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(plannedCost)}
        </span>
        </div>`
    }

    flightStart = (value) => {
        // let isDifferent = flightStart === value?.moFlightStart || flightStart === value?.mohFlightStart ;
        // const flightEnd = value.flight_end ? value.flight_end : value.flightEnd ? value.flightEnd : '';
        
        const isMohTable = value.error_description ? true : false;
        const flightStart = value.flight_start ? value.flight_start : value.flightStart ? value.flightStart : '';
        const normalizedFlightStart = this.normalizeToYMD(flightStart);
        const compareDate = isMohTable ? value?.moFlightStart : value?.mohFlightStart;
        
        const normalizedMoCandidates = this.normalizeToYMD(compareDate);
        const isDifferent = normalizedMoCandidates === normalizedFlightStart;
        return html`<div part="start-date-cell" style="color: ${isDifferent ? '' : 'var(--text-error) !important'}">
        <span>
         ${Utils.formatDateObject(flightStart)}
        </span>
        </div>`
    }

    flightEnd = (value) => {
        const isMohTable = value.error_description ? true : false;
        const flightEnd = value.flight_end ? value.flight_end : value.flightEnd ? value.flightEnd : '';
        const normalizedFlightEnd = this.normalizeToYMD(flightEnd);
        const compareDate = isMohTable ? value?.moflightEnd : value?.mohflightEnd;
        
        const normalizedMoCandidates = this.normalizeToYMD(compareDate);
        const isDifferent = normalizedMoCandidates === normalizedFlightEnd;

        return html`<div part="end-date-cell" style="color: ${isDifferent ? '' : 'var(--text-error) !important'}">
        <span>
         ${Utils.formatDateObject(flightEnd)}
        </span>
        </div>`
    }

    unitAmount = (value) => {
        const isMohTable = value.error_description ? true : false;
        const unitAmount = value.unit_amount ? value.unit_amount : value.placementCost && value.placementCost.unitAmount ? value.placementCost.unitAmount : '';
        const compareUnit = isMohTable ? value?.moUnitAmount : value?.mohUnitAmount;
        const isDifferent = unitAmount === compareUnit;
        return html`<div part="units-cell" style="color: ${isDifferent ? '' : 'var(--text-error) !important'}">
        <span>
         ${unitAmount}
        </span>
        </div>`
    }

    rate = (value) => {
        const isMohTable = value.error_description ? true : false;
        const rate = value.rate ? value.rate : value.placementCost && value.placementCost.rate.amount ? value.placementCost.rate.amount : '';
        const rateWithDecimal = rate ? parseFloat(rate).toFixed(2):'';
        const compareRate = isMohTable ? value?.moRate : value?.mohRate;
        const isDifferent = rateWithDecimal === parseFloat(compareRate).toFixed(2);
        return html`<div part="rate-cell">
        <span style="color: ${isDifferent ? '' : 'var(--text-error)'}">
         ${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(rate)}
        </span>
        </div>`
    }
    
    /**
     * Check date is object and convert to string format yyyy-mm-dd
     * @param {Date} input 
     * @returns date in sting format yyyy-mm-dd
     */
    normalizeToYMD = (input) => {
        if (!input) return '';
        // If already a string in ISO-like format, take the date portion
        if (typeof input === 'string') {
            const s = input.split('T')[0];
            // quick check for yyyy-mm-dd
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
            // try parsing other common string formats
            const parsed = new Date(input);
            if (!isNaN(parsed.valueOf())) {
                const yyyy = parsed.getFullYear();
                const mm = String(parsed.getMonth() + 1).padStart(2, '0');
                const dd = String(parsed.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            }
            return '';
        }
        // If Date or other, try to construct a Date
        const d = new Date(input);
        if (!isNaN(d.valueOf())) {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        }
        return '';
    }
    /**
     * Ensure numeric comparison: convert strings to numbers, strip currency symbols and commas
     * @param v be number or value 
     * @returns numeric value
     */
    toNumber = (v) => {
        if (v === null || v === undefined || v === '') return NaN;
        if (typeof v === 'number') return v;
        if (typeof v === 'string') {
            let s = v.trim();
            // Remove any leading non-numeric characters (like $ or +)
            s = s.replace(/^[^0-9\-\.]+/, '');
            // Remove commas
            s = s.replace(/,/g, '');
            const num = parseFloat(s);
            return isNaN(num) ? NaN : num;
        }
        // Try to coerce other types
        const coerced = Number(v);
        return isNaN(coerced) ? NaN : coerced;
    };

    nestedColumnData = () => [
        {
            label: 'PLACEMENT NAME',
            key: 'placement_taxonomy',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell placement-name-cell">
                ${this.placementName(value)}
                </td>`
            }
        },
        {
            label: 'Type',
            key: 'package_type',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell">
                ${this.type(value)}
                </td>`
            }
        },
        {
            label: 'PARAMETER CODE',
            key: 'parameter_code',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell parameter-code-cell">
                ${this.parameterCode(value)}
                </td>`
            }
        },
        {
            label: 'Net Media',
            key: '',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`
                <style>
                :host::part(net-media-column) {
                    gap: 5px;
                    display: flex;
                    padding: 0 25px;
                    align-items: center;
                }
                </style>
                <td part="table-body-cell">
                <div part="net-media-column">
                <omni-icon icon-id="omni:informative:financial" style='width:18px; height:18px; --color-icon-lines:var(--stroke-success);'></omni-icon>
                ${this.budget(value)}
                </div>
                </td>`
            }
        },
        {
            label: 'TOTAL',
            key: 'planned_cost',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell">
                ${this.totalCost(value)}
                </td>`;
            }
        },
        {
            label: 'START DATE',
            key: 'flight_start',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell">
                ${this.flightStart(value)}
                 </td>`
            }
        },
        {
            label: 'END DATE',
            key: 'flight_end',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell">
                ${this.flightEnd(value)}
                 </td>`
            }
        },
        {
            label: 'UNITS',
            key: 'unit_amount',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell">
                ${this.unitAmount(value)}
                </td>`
            }
        },

        {
            label: 'Rate',
            key: 'rate',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`<td part="table-body-cell">
                ${this.rate(value)}
                </td>`
            }
        }
    ];

    exportStatus = '';
    render() {
        const onSelected = (event,item) => {
            this.exportStatus = event.target.value === 'Media Ops Hub Source' ? 'Ready for prisma' : 'Synced';
            const checkedRadio = document.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                this.setState({ selecedData: item, selectedButtonDisabled: false });
            }
        };

        const onCancel = () => {
            this.props.onSyncErrorModalClose()
            this.setState({ selecedData: {}, selectedButtonDisabled: true });
        }
        /**
         * on selection of opton it will send to mo if select placement is MO else it will update placement if type is Media ocean hub
         */
        const onKeepSelectedOrSendToMo = () => {
            this.props.setSpinnerCount(1);
            const value = this.state.selecedData;
            const placementId = this.props.syncErrorModalData.find(val => val.error_description).id;
            const isMediaOps = this.state.selecedData['error_description'] ? true : false;
            let campaignId = encodeURIComponent(this.props.campaignObj.id);
            
            const payload = SyncErrorService.prepareSyncErrorPayload(value, this.props, this.exportStatus);
            if(!payload[0].supplierCode){
                delete payload[0].supplierCode;
            }
            if (isMediaOps){
                payload[0].keep_selected ='mediaops';
            }
            else{
                payload[0].keep_selected ='mediaocean';
            }
            CreatePlacementOrPackageService.updatePlacementOrPackage(campaignId,placementId,payload[0],this.props?.versionOneApi).then((res) => {
                this.props.setSpinnerCount(0);
                this.setState({ selectedButtonDisabled: true });
                this.props.onSyncErrorModalClose(true)
                if(this.props.statusType === "Needs Update" || this.props.statusType === "Update"){
                    if(isMediaOps){
                        AlertMessagesService.showInfoToastMessage('Please take Approval and Send to Media Ocean');
                    }else{
                        AlertMessagesService.showSuccessToastMessage('Placement/Package successfully updated!');
                    }
                }else{
                    AlertMessagesService.showSuccessToastMessage('You have successfully synced the source option!');
                }
                if (this.props.onPlacementCreate()) {
                    this.props.onPlacementCreate();
                }
            }).catch((error) => {
                this.props.setSpinnerCount(0);
                AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: onKeepSelectedOrSendToMo, title: 'Unable to synce the source option', bodyMsgArr: []}]);
            });
        }

        return (
            <>
                {this.props.isSyncErrorModalOpen && (
                        <div className='sync-error-modal modal is-active'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <div className='modal-header-title'>
                                    {this.props.statusType === 'Sync Error' ? 'Sync' : this.props.statusType} discrepancies between sources
                                    </div>
                                    <hr className='modal-header-divider' />
                                    <div className='modal-header-description'>
                                        Selected the data which you would like to keep and merge with the system.
                                    </div>
                                </div>
                                <div className='modal-middle-section'>
                                    {this.props.syncErrorModalData && this.props.syncErrorModalData.map((item, index) => (
                                        <div className='section-content' key={index}>
                                            <div className='section-content-title'>
                                                <input id={index} type='radio' className='radio-button' value={`${item.error_description ? 'Media Ops Hub Source' : 'Media Ocean Source'}`} name='syncError' onChange={(event) => onSelected(event,item)} />
                                                <label htmlFor={index} className='section-content-title-label'>{item.error_description ? 'Media Ops Hub Source' : 'Media Ocean Source'}</label>
                                            </div>
                                            <div className='section-content-table'>
                                                <OmniTableComponent
                                                    data={[item]}
                                                    columns={this.nestedColumnData()}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='modal-footer'>
                                    <div className='modal-button-group'>
                                        <button className='tertiary' onClick={onCancel}>Cancel</button>
                                        <button disabled={this.state.selectedButtonDisabled} onClick={onKeepSelectedOrSendToMo}>Keep selected</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                )}
                <LoaderComponent
                    spinnerCount={this.state.spinnerCount}
                    displayWholePage={true}
                />
            </>
        );
    };
};

